import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useNavigate, useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

export default function Vegetais() {
    const navigate = useNavigate();
    const location = useLocation();

    // Determina o valor da aba com base no caminho atual da URL
    let value = 0;
    if (location.pathname.endsWith('/verificacao')) {
        value = 1;
    } else if (location.pathname.endsWith('/pedido')) { // Agora verifica a rota '/online'
        value = 2;
    } else if (location.pathname.endsWith('/estoque')) { // Agora verifica a rota '/online'
        value = 3;
    }
    // Se a rota for '/producao/gerar', o valor padrão (0) é mantido.

    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            navigate('/vegetais/movimentacao');
        } else if (newValue === 1) {
            navigate('/vegetais/verificacao');
        } else if (newValue === 2) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/vegetais/pedido');
        } else if (newValue === 3) { // Correção: a terceira aba deve ser newValue === 2
            navigate('/vegetais/estoque');
        }
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="Abas de Produção">
                    <Tab label="Movimentação" />
                    <Tab label="Verificação" />
                    <Tab label="Pedido" />
                    <Tab label="Estoque" />
                </Tabs>
            </Box>
            {/* O Outlet renderizará o conteúdo do componente da rota aninhada */}
            <Outlet />
        </Box>
    );
}

//Movimentação Verificação Pedido Estoque